/**
 * Formar Currency
 */
export const formatCurrency = value => parseFloat(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
